import { useState } from 'react';
import { downloadSignedCollaborativeAgreement } from '@uplift/api';
import { useAlert } from '@uplift/ui-v2';


export const useDownloadAgreement = () => {
  const alert = useAlert();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadAgreement = async (agreementId: string, filename: string) => {
    setIsDownloading(true);
    try {
      const result = await downloadSignedCollaborativeAgreement(agreementId);
      const url = window.URL.createObjectURL(result.data);
      const a = window.document.createElement('a');

      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch {
      alert.error('Failed to download agreement');
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, downloadAgreement };
};
